export enum StaffAccessStatus {
    All = null,
    Active = 1,
    Inactive = 0
}